// function 



export default (defaults) => ({

    mouseX: 0,
    mouseY: 0,
    showCursor: false,
    total: null,
    
    init() {
        // set weight
        if(window.location.hash.indexOf('wght') > -1) {
            let wght = window.location.hash.split('--wght:')[1].split('--')[0];
            console.log('wght: ' + wght);
            this.axes.wght = wght;
        }

        // set optical size
        if(window.location.hash.indexOf('opsz') > -1) {
            let opsz = window.location.hash.split('--opsz:')[1].split('--')[0];
            console.log('opsz: ' + opsz);
            this.axes.opsz = opsz;
        }

        // set widths
        if(window.location.hash.indexOf('wdth') > -1) {
            let wdth = window.location.hash.split('--wdth:')[1].split('--')[0];
            console.log('wdth: ' + wdth);
            this.axes.wdth = wdth;
        }

        this.activeStyle = this.currentStyle()
        
    },

    updateMouse(e) {
        this.mouseX = e.clientX;
        this.mouseY = e.clientY;
        if(!window.isMobile) {
            this.showCursor = true;
        }
    },

    loadIn() {
        let el = this.$el;
        setTimeout(function() {
            console.log(el.classList.remove('out'));
        }, 500)
    },

    titleCase(str) {
        return str.toLowerCase().replace(/(?:^|[\s-/])\w/g, function (match) {
            return match.toUpperCase();
        });
    },

    family: window.location.hash ? window.location.hash.split('__')[1].split('--')[0] : defaults.defaultFamily,
    weight: false,
    features: false,
    defaultSize: isMobile ? defaults.defaultMobile : defaults.defaultDesktop,
    axes: defaults.axes,
    otFeatures: defaults.otFeatures,
    activeStyle: '',
    
    smaller() {
        console.log('smaller text');
        this.defaultSize = this.defaultSize - this.defaultSize * .25;
    },

    reset() {
        console.log('reset text')
        this.defaultSize = defaults.defaultMobile;
    },
    larger() {
        console.log('larger text')
        this.defaultSize = this.defaultSize + this.defaultSize * .25;
    },

    currentStyle() {
        if(window.location.hash) {
            let style =  this.titleCase(decodeURI(window.location.hash.split('__')[0].split('#')[1].replaceAll('_', ' ')));
            if(style.indexOf('No ') > -1) {
                style.replace();
                let num = style.split('No ')[1];                 
                return '№' + num;
            } else {
                return style 
            }
        } else {
            
            return defaults.currentStyle;
        }
    },

    

    toggleWeight(e) {
        this.features = false;
        this.weight = ! this.weight;
    },
    
    toggleFeatures(e) {
        this.weight = false;
        this.features = ! this.features;
    },
    
});